import {ScomponentMode} from "@/components/dto/ScomponentMode";

export class ScomponentModeImpl implements ScomponentMode {
    editable: boolean = false;
    delete: boolean = false;
    addHint: boolean = false;
    moveComponent: boolean = false;

    constructor(editMode: boolean, deleteMode: boolean, addHint:boolean, moveComponent:boolean){
        this.editable = editMode;
        this.delete = deleteMode;
        this.addHint = addHint;
        this.moveComponent = moveComponent
    }

   empty(): ScomponentMode{
       return {
           editable: false,
           delete: false,
           addHint:false,
           moveComponent:false
       }
   }

}
